export enum DroppanelStyle {
    Default = '',
    FollowsParentWidth = '-sh-is-full-width'
}
